import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ReactCountryFlag from 'react-country-flag';
import { useTranslation } from 'react-i18next';
import { languages, resolveAuthLang } from '@app/i18n';

export default function AuthLayout({ children, className = '' }) {
  const { i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const rawLang = searchParams.get('lang');
  const lang = resolveAuthLang(rawLang);
  const currentLanguage = languages.find((item) => item.value === lang);

  const applyLangToUrl = useCallback(
    (value) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set('lang', value);
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }

    if (rawLang !== lang) {
      applyLangToUrl(lang);
    }
  }, [lang, rawLang, i18n, applyLangToUrl]);

  const toggleLanguage = () => {
    applyLangToUrl(lang === 'en' ? 'ru' : 'en');
  };

  return (
    <section className={`auth ${className}`}>
      <div className="auth__container">
        <button
          type="button"
          className="auth-lang-switcher"
          onClick={toggleLanguage}
        >
          <ReactCountryFlag svg countryCode={currentLanguage.flag} />
          <span>{currentLanguage.label}</span>
        </button>
        {children}
      </div>
    </section>
  );
}
